export class CustomAddress {
    id : number;
    screeningId : number;
    screeningToken : string;
    street : string;
    street2 : string;
    city : string;
    state : string;
    zipCode : string;
    countryCode : number;
    dateFirstReported: string;
	dateLastReported: string;
    notes : string;
}